import * as React from "react"

import DartIcon from '../assets/images/icons/dart.svg';
import FlutterIcon from '../assets/images/icons/flutter.svg';
import GatsbyIcon from '../assets/images/icons/gatsby.svg';
import GitIcon from '../assets/images/icons/git.svg';
import GithubIcon from '../assets/images/icons/github.svg';
import GitlabIcon from '../assets/images/icons/gitlab.svg';
import IdeaIcon from '../assets/images/icons/idea.svg';
import IosIcon from '../assets/images/icons/ios.svg';
import JavascriptIcon from '../assets/images/icons/javascript.svg';
import NotionIcon from '../assets/images/icons/notion.svg';
import PhpIcon from '../assets/images/icons/php.svg';
import RailsIcon from '../assets/images/icons/rails.svg';
import RubyIcon from '../assets/images/icons/ruby.svg';
import TypescriptIcon from '../assets/images/icons/typescript.svg';

let icons = {
  'Android': '',
  'Dart': DartIcon,
  'Flutter': FlutterIcon,
  'Gatsby': GatsbyIcon,
  'Git': GitIcon,
  'GitHub': GithubIcon,
  'GitLab': GitlabIcon,
  'アイデア': IdeaIcon,
  'iOS': IosIcon,
  'JavaScript': JavascriptIcon,
  'Notion': NotionIcon,
  'PHP': PhpIcon,
  'Ruby on Rails': RailsIcon,
  'Ruby': RubyIcon,
  'React.js': '',
  'TypeScript': TypescriptIcon,
};

const TagIcon = ({tag}) => {
  return (
    <div className="tag-icon-container">
      <img className="tag-icon-img" src={icons[tag]} alt={tag}/>
      <span  className="tag-icon-label">{tag}</span>
    </div>
  )
}

export default TagIcon
